import { InputProps } from '../../types/InputProps';
import { Info } from '../icons/Info';

export const Input = ({ name, placeholder, value, required, errorMessage, onChange }: InputProps) => {
  
  return (
    <div className="relative">
      <div className='relative'>
        <input
          type="text"
          id={name}
          className="peer block w-full px-4 py-2 bg-transparent border-0 border-b border-custom-border text-bluestone-light placeholder-transparent focus:border-bluestone-light focus:outline-none focus:ring-0"
          required={required}
          name={name}
          defaultValue={value}
          placeholder=" " // Leave placeholder blank
          onChange={ (e) => {
            onChange(e);
          }}
        />
        <label
          htmlFor={name}
          className="absolute left-4 top-0 bottom-0 self-center transition-all duration-200 text-base text-[#606F82] opacity-0 peer-placeholder-shown:opacity-100 peer-empty:opactity-100"
        >
          {value || placeholder}
          {required && <span className="text-error ml-1">*</span>}
        </label>
      </div>
      {errorMessage && (
        <div className='flex text-error mt-2'>
          <Info variant='currentColor' className='mr-2' />
          {errorMessage}
        </div>
      )}
    </div>
  );
};
